import React from 'react';
import { useState, useEffect, useRef } from "react";
import "./portfolio.css";
import { motion } from "framer-motion";
import img1 from "../../Img/1.jpeg";
import img2 from "../../Img/2.jpg";
import img3 from "../../Img/3.jpg";
import img4 from "../../Img/4.jpg";
import img5 from "../../Img/5.jpg";
import img6 from "../../Img/6.1.jpg";


const images = [img1, img2, img3, img4, img5, img6]


function Portfolio() {
    const carousel = useRef();
    const [width, setWidth] = useState(0);

    useEffect(() => {
        console.log(carousel.current?.scrollWidth, carousel.current?.offsetWidth)
        setWidth(carousel.current?.scrollWidth - carousel.current?.offsetWidth)
    }, []);

    return (
        <>
            <section className="portfolio top" id="Portfolio">
                <div className="container">
                    <div className="heading text-center">
                        <motion.h1 animate={{ x: 50 }}>Nossos treinamentos</motion.h1>
                    </div>
                </div>
                </section>

            <motion.div ref={carousel} className="carousel" whileTap={{ cursor: "grabbing" }}>
                <motion.div
                    className="inner"
                    drag="x"
                    dragConstraints={{ right: 0, left: -width }}
                    initial={{ x: 100 }}
                    animate={{ x: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    {images.map(image => (
                        <motion.div className="item" key={image}>
                            <img src={image} alt="text alt" />
                        </motion.div>
                    ))}
                </motion.div>
            </motion.div>
            
        </>
    )
}

export default Portfolio